'use strict';




export default function setupSidebar () {
    const mainHeader = document.querySelector('.main-header');
    const sidebar = document.querySelector('body.categories .sidebar, body.sales .sidebar, body.nieuw .sidebar, body.brands .sidebar, body.search .sidebar');

    if ( mainHeader && sidebar ) {
        const headerHeight = mainHeader.getBoundingClientRect().height;
        const sidebarHeight = sidebar.getBoundingClientRect().height;
        const windowHeight = window.innerHeight;

        const offsetTop = sidebarHeight > (windowHeight - headerHeight)
                            ? 0 - sidebarHeight + windowHeight
                            : headerHeight + 15;

        sidebar.style.top = offsetTop + 'px';
    }
}
